import React,{ Component } from 'react';
import Charts from './Charts/Charts';
import ChartLine from './Charts/ChartLine';
import copyright from '../img/copyright-gray.png';
import firebase from 'firebase'

class Home extends Component{
	
	constructor(){
		super();
		this.state={
			isProduccion:true
		}

		this.verifyIsTest();
	}
	
	verifyIsTest = async ()=>{
		const snap = await firebase.database().ref().child('properties').child('isProduccion').once('value');
		const result = snap.val();


		if(result)
			this.setState({isProduccion:true});
		else
			this.setState({isProduccion:false});
	}
	

	render(){
		
		return(
		
		
			<div className="home">
				{
					!this.state.isProduccion?
					(
						<div className="row">
							<h2 className='col-sm-12 text-center font-weight-bold'>Ambiente de TEST</h2>
						</div>
					)
					:null
				}
				
				<div className="row">
						
						<div className="col-md-1">
							
						</div>
						<div className="col-md-5">
							<center><h4 className="titulo-graficos">Usuarios registrados los ultimos 3 meses</h4></center>
							<Charts/>
						</div>
						
						<div className="col-md-5">
							<center><h4 className="titulo-graficos">Viajes ultimos 3 meses</h4></center>
							<ChartLine/>
						</div>
												
						<div className="col-md-1">
							
						</div>
						
					
				</div>
				<footer className="footer-pg mt-auto py-3" style={{width:'100%', position:'fixed'}}>
					<div className="container">
						<div className="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div className="col-sm">
								<img src={copyright}/>
							</div>
						</div>
					</div>
					</footer>	
			</div>
		
		);
		
		
	}
	
	
}


export default Home;


// WEBPACK FOOTER //
// ./src/Components/Home.jsx